export default function isEmpty(t){return t&&0===Object.keys(t).length&&Object.getPrototypeOf(t)===Object.prototype}